import messages from '../Campaigns.messages';

export const DEFAULT_TIME_SLOT = { startTime: '09:00', endTime: '17:00' };

export const TIME_SLOT_INTERVAL_MINUTES = 15;

export const SCHEDULE_DAYS = [
  { value: 0, message: messages.form.daySunday, messageFull: messages.form.daySundayFull },
  { value: 1, message: messages.form.dayMonday, messageFull: messages.form.dayMondayFull },
  { value: 2, message: messages.form.dayTuesday, messageFull: messages.form.dayTuesdayFull },
  { value: 3, message: messages.form.dayWednesday, messageFull: messages.form.dayWednesdayFull },
  { value: 4, message: messages.form.dayThursday, messageFull: messages.form.dayThursdayFull },
  { value: 5, message: messages.form.dayFriday, messageFull: messages.form.dayFridayFull },
  { value: 6, message: messages.form.daySaturday, messageFull: messages.form.daySaturdayFull },
];
